module.exports = __webpack_public_path__ + "img/right.2068cd7f.svg";